export default __webpack_public_path__ + "static/media/msz.6710067d.PNG";